/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content/SlotSelect/Content/Content/Content/Options/Option/Multiple/Content/Options/Option"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let groupMemberSelectedValueData = fromData.useDataValue({ viewPath,
context: 'groupMember',
path: 'selected',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let groupMemberChairNameValueData = fromData.useDataValue({ viewPath,
context: 'groupMember',
path: 'chair_name',
})
let groupMemberSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'groupMember',
path: 'selected',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<button
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-Z2h7tiu': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-2-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z2h7tiu': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-4-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-8-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-Z2h7tiu': isHovered ? dtColorsNeutral100 : groupMemberSelectedValueData ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 style={{'--g-10-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral900}
 data="groupMember.chair_name"
 text={groupMemberChairNameValueData}
 weight={groupMemberSelectedValueData1 ? "medium" : "regular"}
 data="groupMember.selected"
/>
</div>
</button>
{children}
</React.Fragment>)
}